@if (summary(); as s) {
  @if (s.isVisible) {
    <section
      class="toast"
      [class.toast--expanded]="expanded()"
      [class.toast--error]="hasError()"
      [class.toast--complete]="isCompleted()"
      [dataSelector]="dataSelector"
      role="status"
      aria-live="polite"
    >
      <header class="toast-header">
        <div class="toast-header-lead">
          <aiwyn-icon
            class="toast-header-icon"
            [name]="headerIcon()"
            [height]="20"
            [width]="20"
            [dataSelector]="dataSelector + '-icon'"
          />
          <div class="toast-header-text">
            <span class="toast-title" [dataSelector]="dataSelector + '-title'">{{ title() }}</span>
            @if (subtitle(); as sub) {
              <span
                class="toast-subtitle"
                [class.toast-subtitle--error]="hasError()"
                [dataSelector]="dataSelector + '-subtitle'"
              >{{ sub }}</span>
            }
          </div>
        </div>

        <div class="toast-header-actions">
          <button
            type="button"
            class="toast-icon-btn"
            (click)="toggleExpanded()"
            [attr.aria-label]="expanded() ? 'Collapse upload progress' : 'Expand upload progress'"
            [attr.aria-expanded]="expanded()"
            [dataSelector]="dataSelector + '-toggle'"
          >
            <aiwyn-icon [name]="expanded() ? 'chevron-up' : 'chevron-right'" [height]="16" [width]="16" />
          </button>
          @if (isCompleted()) {
            <button
              type="button"
              class="toast-icon-btn"
              (click)="dismiss()"
              aria-label="Dismiss upload progress"
              [dataSelector]="dataSelector + '-dismiss'"
            >
              <aiwyn-icon name="x" [height]="16" [width]="16" />
            </button>
          }
        </div>
      </header>

      <!-- Collapsed + in-progress: slim overall bar with percent. -->
      @if (!expanded() && !isCompleted()) {
        <div class="toast-progress-slim">
          <mat-progress-bar
            class="toast-bar"
            [class.toast-bar--error]="hasError()"
            mode="determinate"
            [value]="s.percent"
          />
          <span class="toast-percent">{{ s.percent }}%</span>
        </div>
      }

      @if (expanded()) {
        <!-- Expanded + in-progress: overall bar + bytes + percent. -->
        @if (!isCompleted()) {
          <div class="toast-overall">
            <mat-progress-bar
              class="toast-bar"
              [class.toast-bar--error]="hasError()"
              mode="determinate"
              [value]="s.percent"
            />
            <div class="toast-overall-meta">
              <span [dataSelector]="dataSelector + '-bytes'">
                {{ s.bytesLoaded | fileSize: 1 }} of {{ s.bytesTotal | fileSize: 1 }}
              </span>
              <span>{{ s.percent }}%</span>
            </div>
          </div>
        }

        <ul class="toast-list" [dataSelector]="dataSelector + '-list'">
          @for (jobId of jobIds(); track jobId) {
            <li class="toast-list-item">
              <awn-file-upload-job-item [jobId]="jobId" [compact]="true" mode="client-request" />
            </li>
          }
        </ul>

        <footer class="toast-footer">
          @if (isCompleted()) {
            <button
              andButton
              color="primary"
              size="small"
              class="toast-footer-btn"
              (click)="dismiss()"
              [dataSelector]="dataSelector + '-upload-more'"
            >
              Upload More Files
            </button>
          } @else {
            @if (s.erroredCount > 0) {
              <span class="toast-footer-errors" [dataSelector]="dataSelector + '-error-count'">
                <aiwyn-icon name="alert-circle" class="toast-footer-error-icon" [height]="16" [width]="16" />
                {{ s.erroredCount }} {{ s.erroredCount === 1 ? 'error' : 'errors' }}
              </span>
            }
            <button
              andButton
              color="primary"
              size="small"
              class="toast-footer-btn"
              (click)="cancelAll()"
              [dataSelector]="dataSelector + '-cancel-all'"
            >
              Cancel All
            </button>
          }
        </footer>
      }
    </section>
  }
}
